import { IPoint } from "./Geometry";


export interface IListener {
    element: HTMLElement;
    event: string;
    listener: Function;
}

export function clearEvents(...listeners: IListener[]) {
    for (const item of listeners)
        item.element.removeEventListener(item.event, item.listener as any);
}

export function attachEvents(...listeners: IListener[]) {
    for (const item of listeners)
        item.element.addEventListener(item.event, item.listener as any);
}

export function onDown(element: HTMLElement, handler: (ev: TouchEvent | PointerEvent, data: Touch | PointerEvent, pointerId?: number) => void) {

    const result: IListener[] = [];

    if (navigator.maxTouchPoints > 0) {
        result.push({
            element,
            event: "touchstart",
            listener: ev => {
                if (ev.touches.length == 1) {
                    handler(ev, ev.touches[0]);
                    ev.preventDefault();
                    ev.stopPropagation();
                    ev.stopImmediatePropagation();
                }

            }
        });

    }
    else {

        const listner = {
            element,
            event: "pointerdown",
            listener: (ev: PointerEvent) => {
                handler(ev, ev, ev.pointerId);
            }
        } as IListener;

        result.push(listner);

        result.push({
            element,
            event: "touchstart",
            listener: ev => {
                ev.preventDefault();
                ev.stopPropagation();
                ev.stopImmediatePropagation();
            }
        });
        
    }

    attachEvents(...result);

    return result;
}

export function onUp(element: HTMLElement, handler: (ev: TouchEvent | PointerEvent, data: Touch | PointerEvent) => void) {

    const result: IListener[] = [];

    if (navigator.maxTouchPoints > 0) {
        result.push({
            element,
            event: "touchend",
            listener: ev => {
                if (ev.touches.length == 0)
                    handler(ev, ev.changedTouches[0]);
            }
        });
    }
    else {
        result.push({
            element,
            event: "pointerup",
            listener: ev => {
                handler(ev, ev);
            }
        });
    }

    attachEvents(...result);

    return result;
}

export function onMove(element: HTMLElement, handler: (ev: TouchEvent | PointerEvent, data: Touch | PointerEvent) => void) {

    const result: IListener[] = [];

    if (navigator.maxTouchPoints > 0) {
        result.push({
            element,
            event: "touchmove",
            listener: ev => {
                if (ev.touches.length == 1) {
                    handler(ev, ev.touches[0]);
                    ev.preventDefault();
                    ev.stopPropagation();
                    ev.stopImmediatePropagation();
                }

            }
        });

    }
    else {

        result.push({
            element,
            event: "pointermove",
            listener: ev => {
                handler(ev, ev);
            }
        });

        result.push({
            element,
            event: "touchmove",
            listener: ev => {
                ev.preventDefault();
                ev.stopPropagation();
                ev.stopImmediatePropagation();
            }
        });
    }

    attachEvents(...result);

    return result;
}


export function onDrag(element: HTMLElement, down: (pos: IPoint, button?: number, ev?: PointerEvent | TouchEvent) => boolean, move: (pos: IPoint, startPos?: IPoint, ev?: PointerEvent | TouchEvent) => boolean, up: (pos: IPoint, startPos?: IPoint, ev?: PointerEvent | TouchEvent) => void) {

    let lastPointerId: number;
    let startPos: IPoint;
    let isMoving = false;
    let moveData: IListener[];
    let upData: IListener[];


    return onDown(element, (ev, data, pointerId) => {

        startPos = { x: data.clientX, y: data.clientY };

        lastPointerId = pointerId;

        if (down({ x: data.clientX, y: data.clientY }, (ev as PointerEvent).button ?? 0, ev)) {
            if (pointerId !== undefined)
                (ev.target as HTMLElement).setPointerCapture(lastPointerId);
        }

        isMoving = true;

        moveData = onMove(element, (ev, data) => {

            if (!isMoving)
                return;
            if (!move({ x: data.clientX, y: data.clientY }, startPos, ev)) {
                isMoving = false;
            }
        
        });

        upData = onUp(element, (ev, data) => {

            if (!isMoving)
                return;

            if (pointerId !== undefined)
                (ev.target as HTMLElement).releasePointerCapture(pointerId);

            up({ x: data.clientX, y: data.clientY }, startPos, ev);
            clearEvents(...upData);
            clearEvents(...moveData);

        });

    })
}